import oneOnOneTemplatesTranslations from "./oneOnOneTemplatesTranslations";
import teamTemplatesTranslations from "./teamTemplatesTranslations";

export default {
	templates: {
		...oneOnOneTemplatesTranslations,
		...teamTemplatesTranslations,
	},
};
